import React from "react";
import {Grid} from "@material-ui/core";
import QuestionMark from "../../../assets/images/q_mark.png";
import GoldBanner from "../../../assets/images/gold_banner.png";
import gold from "../../../assets/images/ic_coin.png";

import SingleOffer from "../Market/SingleOffer";
import GreenBtn from "../../../assets/images/btn_green_store.png";
import RedBtn from "../../../assets/images/btn_red_store.png";
import {numberSplitor} from "../../../Utility/Func";
import Button from "../Settings/Free/Button";
import PicoLoader from "./PicoLoader";
import axios from "axios";
import {buy} from "../../../Utility/Url";
class SpecialOfferDialog extends React.Component{
    state={
        remainingTime:null,
        seconds:4000,
        picoSmallLoader:false
    }
    componentDidMount() {
        this.setState({
            seconds:this.props.data.data.timeLeft
        })
        setInterval(()=>{
                const timeString=new Date(this.state.seconds * 1000).toISOString().substr(11, 8);
                this.setState({
                    remainingTime:timeString,
                    seconds:this.state.seconds-1
                })
            }
            , 1000);
    }
    pay= async(id)=>{
        this.setState({
            picoSmallLoader:true
        })
        const {appliedDiscountCode}=this.state
        const URL = process.env.REACT_APP_BASE_URL
        await axios.post(buy,{
            code:!appliedDiscountCode?'':appliedDiscountCode,
            id:id,
            url:`${URL}/home`
        })
            .then(res => {
                const {data}=res
                this.setState({
                    picoSmallLoader:false
                })
                localStorage.setItem('redirect','/home')
                window.location.href=data.url
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    render() {
        const {success,
            type,
            strAction,
            action,
            imgUrl,
            message,
            light,
            prizeType,
            prizeVal,
            data:{
                // action,
                bgColor,
                descc,
                finish,
                iconMain,
                img,
                textAction,
                timeLeft,
                title,
                titleMain,
                // type,
            },
            shopItem:{
                bannerActive,
                bannerUrl,
                fullPrice,
                giftVal,
                icon,
                id,
                isVisible,
                name,
                price,
                qIcon,
                quantity,
                // type,
                typeDesc,
            }

        }=this.props.data
        const singleOffer={
            price:'',
            qIcon:qIcon,
            fullPrice:'',
            icon:icon,
            quantity:quantity

        }
        const {picoSmallLoader}=this.state
        return(
            <Grid direction={"column"}
                  item
                  container
                  className={'help-dialog'}
                  style={{
                      background: 'linear-gradient(90deg, rgba(219,166,43,1) 23%, rgba(255,252,0,1) 98%)'
                  }}
                  justify={"space-around"} alignItems={"center"}
            >
                <Grid container alignItems={"center"} style={{position:'relative'}} justify={"center"}>
                    <Grid  xs={3} sm={3} container alignItems={"center"} justify={"center"}
                        style={{
                            position:'relative'
                        }}
                        >
                        <img src={light} style={{position:'absolute',width:'200%'}} className='lightAnimation' alt=""/>
                        <img src={iconMain} style={{position:'absolute'}} alt=""/>
                    </Grid>
                    <Grid className={'help-dialog-inner'} sm={12} xs={12}
                          alignItems={"center"}
                          justify={"center"}
                          direction={"column"}
                        style={{
                            whiteSpace: 'pre-line',
                            textAlign: 'center',
                            padding:'0',
                            overflow:'hidden',
                            marginTop:'20px'
                        }}
                    >
                        <Grid container alignItems={"center"} justify={"flex-end"}>
                            <Grid xs={4} sm={4}
                                  className='wallet-button-content-message-inner-title'
                                  container
                                  alignItems={"center"}
                                  justify={"center"}
                                style={{background:'linear-gradient(90deg, rgba(191,45,138,1) 28%, rgba(127,0,255,1) 81%)'}}
                            >
                                {this.state.remainingTime}
                            </Grid>
                        </Grid>
                        <Grid style={{marginTop:'20px'}} container alignItems={"center"} justify={"center"}>
                            {title}
                        </Grid>
                         <Grid style={{margin:'20px 0 20px 0'}} container alignItems={"center"} justify={"center"}>
                             {descc}
                        </Grid>
                        <Grid  container alignItems={"center"} justify={"center"}>
                            <Grid sm={4} xs={4} container alignItems={"center"} justify={"center"}>
                                <SingleOffer data={singleOffer}/>
                            </Grid>
                        </Grid>
                        <Grid  container alignItems={"center"} justify={"center"} style={{marginBottom:'20px'}}>
                            <Grid sm={4} xs={4} container alignItems={"center"} justify={"center"}>
                                <p className='offer-section-single-offer-span-outer'>
                                    {numberSplitor(fullPrice)}
                                </p>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid  container alignItems={"center"} justify={"center"}>
                        <Grid xs={4} sm={4} container alignItems={"center"} justify={"center"}
                               style={{
                                   position:'absolute'
                               }}
                        >
                            {
                                picoSmallLoader &&
                                <Grid sm={3} xs={3} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                                      style={{position:'relative',height:'50px'}}
                                >
                                    <Grid item container justify={"center"} alignItems={"center"} style={{position:'absolute'}}>
                                        <PicoLoader/>
                                    </Grid>
                                </Grid>
                            }
                            {
                                !picoSmallLoader &&
                                <Grid sm={12} xs={12} container alignItems={"center"} justify={"center"}>
                                    <Grid style={{
                                        backgroundImage: "url(" + GreenBtn + ")",
                                        backgroundSize: 'contain',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: '50% 50%',
                                        // width:'15%'
                                        backgroundColor: ''
                                    }} container
                                          justify={"center"} alignItems={"center"}
                                          className='offer-section-single-offer-price-section clickable'
                                          direction={"row"}
                                          onClick={()=>{
                                              this.pay(id)
                                          }}
                                    >
                                        <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                            <p className='offer-section-single-offer-text'>
                                                {numberSplitor(price)}
                                            </p>
                                        </Grid>
                                        <Grid container alignItems={"center"} justify={"center"} sm={1} xs={1}/>
                                        <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                            <p className='offer-section-single-offer-text'>
                                                تومان
                                            </p>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
export default SpecialOfferDialog